/* eslint-disable no-useless-escape */
/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */

import { ensureSwiper, ensureBasicSwiper } from "../shared/swiper-runtime";

//----------------------------------------------------------------//
// IMPORTS & GLOBALS

window.bcl = window.bcl || {};
window.bcl.u = window.bcl.u || {};

const DOC = document;
const DOC_EL = DOC.documentElement;
const HEAD = DOC.head || DOC.getElementsByTagName("head")[0];
const WIN = window;
const LOC = WIN.location;
const ORIGIN = LOC.origin;
const UA = (WIN.navigator && WIN.navigator.userAgent) || "";

const crossOriginURLS = /booking.barcelo.com|reservation.barcelo.com/;
WIN.crossOriginURLS = WIN.crossOriginURLS || crossOriginURLS;

bcl.u._externalScriptPromises = bcl.u._externalScriptPromises || Object.create(null);
bcl.u._externalStylePromises = bcl.u._externalStylePromises || Object.create(null);

const utils = WIN.bcl.u;
utils.loadedStylesKeys = utils.loadedStylesKeys || new Set();
utils._cssPromises = utils._cssPromises || new Map();

//----------------------------------------------------------------//
//--------------------------- A ---------------------------//
//----------------------------------------------------------------//

bcl.u.activeBooking = function ($element) {
  bcl.u.addClass($element.parentNode, "hidden");

  const $card = $element.closest("." + bcl.c.distributor.results.props.classNameCard);
  if (!$card) {
    return;
  }

  let $node = $card.getElementsByClassName("mod--cta-disabled");
  if ($node && $node[0]) {
    $node = $node[0];

    bcl.u.removeClass($node, "mod--cta-disabled");

    if (bcl.u.containsClass($node, "promo-button-JS")) {
      bcl.u.addClass($node, "mod--cta-color-red");
      bcl.u.removeClass($node, "mod--cta-outline");
    }
  }
};

//----------------------------------------------------------------//

bcl.u.addBhgLoading = function ($container, defaultLoader, isFullScreen) {
  bcl.s.loading?.loadStyles?.();

  const $content = DOC.createElement("div");

  const loaderHtmlBuilder = [];
  let loaderHtml = "";

  const loaderAnimation =
    // eslint-disable-next-line @stylistic/js/max-len
    '<div class="bhg-loading dynamicLoading hiddenComponent mod--loading-active common-transition"><div class="bhg-loading__logo"> <?xml version="1.0" encoding="utf-8"?> <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 362.2 378.4" style="enable-background:new 0 0 362.2 378.4;" xml:space="preserve"><style type="text/css">.st0{fill:#384044}.st1{fill:none;stroke:#384044;stroke-miterlimit:10}.st2{fill:none;stroke:#384044;stroke-width:1.2853;stroke-miterlimit:10}.st3{fill:none;stroke:#384044;stroke-width:1.285;stroke-miterlimit:10}</style><g id="b-fill"> <path class="st0" d="M228.1,178.7c17.2-10.5,25.6-25.6,25.6-46.1c0-39.1-23.5-58.1-71.7-58.1H80c-1.4,0-2.5,1.2-2.5,2.6v223.6 c0,1.5,1.1,2.6,2.5,2.6h105c36.4,0,79-17.7,79-67.5C264,207.9,251.3,187.8,228.1,178.7z M130.1,118h42.1c20.6,0,30.2,7.3,30.2,23.1 c0,19.8-14.5,24-26.6,24h-45.7V118L130.1,118z M178.6,260h-48.4v-56.1h49.3c21.4,0,31.7,9.6,31.7,29.3 C211.2,251.2,200.5,260,178.6,260z"/> </g> <g id="b-hole-1"> <path class="st1" d="M130.1,165.1"/> <path class="st1" d="M175.8,165.1h-45.7V118l46.1,0.1c0,0,26.2-2.2,26.2,23S175.8,165.1,175.8,165.1z"/> </g> <g id="b-hole-2"> <path class="st1" d="M181.3,260h-51.1v-56.1l51.1-0.1c0,0,29.7-1.9,29.7,28.1S181.3,260,181.3,260z"/> </g> <g id="b-stroke"> <path class="st1" d="M77.5,141.6"/> <path class="st1" d="M77.5,165.2V76.9c0,0-0.1-0.7,0.7-1.5s1.5-0.8,1.5-0.8h101.6c0,0,70.1-4.4,72.2,52.1 c2.6,39.1-25.4,52.1-25.4,52.1s35.8,13.7,35.8,53.3c0,76.8-82.6,71.3-82.6,71.3H79.8c0,0-0.8,0-1.5-0.7s-0.7-1.6-0.7-1.6v-41 L77.5,165.2z"/> </g> <g id="circle"> <path class="st2" d="M67.5,188.2v-0.5C68,124.7,119.6,74,182.6,74.5l0,0c62.9,0.5,113.5,51.8,113.2,114.6v0.5 c-0.3,63.2-51.9,114.2-115.1,113.7l0,0C117.7,302.7,67,251.2,67.5,188.2z"/> </g> <g id="line-top"> <line class="st2" x1="37.5" y1="74.4" x2="293.9" y2="74.5"/> </g> <g id="line-bottom"> <line class="st2" x1="293.9" y1="303.4" x2="37.5" y2="303.4"/> </g> <g id="line-section-right"> <line class="st3" x1="276.2" y1="14.6" x2="232.5" y2="86.4"/> </g> <g id="line-section-left"> <line class="st2" x1="77.5" y1="178.7" x2="67.4" y2="88.1"/> </g> </svg> </div>';
  const loaderClosing = "</div>";

  if (bcl.s.loading.props.loader && !defaultLoader) {
    loaderHtmlBuilder.push(bcl.s.loading.props.loader.outerHTML);
  } else {
    if ($container?.dataset.loadingtitle || $container?.dataset.loadingsubtitle) {
      const loaderText = `<div class="bhg-loading-title">${$container.dataset.loadingtitle}</div><div class="bhg-loading-subtitle">${$container.dataset.loadingsubtitle}</div>`;
      loaderHtmlBuilder.push(loaderAnimation, loaderText);
    } else {
      loaderHtmlBuilder.push(loaderAnimation);
    }
    loaderHtmlBuilder.push(loaderClosing);
  }

  loaderHtml = loaderHtmlBuilder.join("");

  $container?.classList.add("mod--bhg-loading");
  if ($container && !isFullScreen) {
    if (WIN.innerHeight < $container.offsetHeight) {
      $container.style.height = `${WIN.innerHeight - 100}px`;
    }
    $content.innerHTML = loaderHtml;
  } else {
    $container = DOC.body;
    if (bcl.s.loading.props.loader) {
      bcl.u.addClass(bcl.s.loading.props.loader, "mod--fullscreen");
    }
    $content.innerHTML = loaderHtml.replace("mod--loading-active", "mod--fullscreen mod--loading-active");
  }
  $container.appendChild($content);
};

//----------------------------------------------------------------//

bcl.u.addClass = function ($el, className) {
  if (!$el || !className) {
    return;
  }

  if (Array.isArray($el)) {
    for (let i = 0; i < $el.length; i++) {
      bcl.u.addClass($el[i], className);
    }
    return;
  }

  const cl = $el.classList;
  if (cl) {
    const parts = String(className).trim().split(/\s+/);
    for (let i = 0; i < parts.length; i++) {
      const c = parts[i];
      if (c) {
        cl.add(c);
      }
    }
  } else {
    $el.className += " " + className;
  }
};

//----------------------------------------------------------------//

bcl.u.addSpinner = function ($container) {
  bcl.u.addClass($container, "loading-dots");
};

//----------------------------------------------------------------//
//--------------------------- B ---------------------------//
//----------------------------------------------------------------//

bcl.u.browser = (function () {
  const isEdge = /Edg|EdgiOS|Edge/i.test(UA);
  const isFirefox = /Firefox|FxiOS/i.test(UA);
  const isChromium = /Chrome|CriOS|Chromium/i.test(UA) && !isEdge;
  const isChrome = /Chrome|CriOS/i.test(UA) && !isEdge;
  const isOpera = /OPR|Opera/i.test(UA);
  const isSamsungBrowser = /SamsungBrowser/i.test(UA);
  const isSafari = /Safari/i.test(UA) && !isChromium && !isEdge && !isFirefox && !isOpera && !isSamsungBrowser;

  return {
    isChrome: function () {
      return isChrome;
    },
    isChromium: function () {
      return isChromium;
    },
    isEdge: function () {
      return isEdge;
    },
    isFirefox: function () {
      return isFirefox;
    },
    isSafari: function () {
      return isSafari;
    },
  };
})();

//----------------------------------------------------------------//
//--------------------------- C ---------------------------//
//----------------------------------------------------------------//

bcl.u.calculateDecimalsByExponent = function (value, exponent) {
  return Math.round(value / Math.pow(10, exponent));
};

//----------------------------------------------------------------//

bcl.u.callWhenLoadUser = function (callWhenReady) {
  const loginErrorCookie = bcl.cookie.get(bcl.contextHub.props.lasukmybErrorCookie);
  const hasMybSession = Boolean(
    bcl.cookie.get("login-token") || bcl.cookie.get("bhg-user") || bcl.cookie.get("bhg-ciam-user") || bcl.cookie.get("ROCP_token") || bcl.cookie.get("ROCP_idToken") || bcl.cookie.get(bcl.contextHub.props.lasukmybCookie) === "1",
  );

  if (bcl.contextHub.props.loginError && bcl.contextHub.props.loginError.includes(loginErrorCookie)) {
    if (!hasMybSession) {
      bcl.cookie.remove(bcl.contextHub.props.lasukmybErrorCookie, "/");
    } else {
      const loginErrorModal = DOC.querySelector(".modal-login-error-JS");
      if (loginErrorModal && loginErrorModal.dataset.logout) {
        const logoutUrl = bcl.u.getbase64DecodedUrl(loginErrorModal.dataset.logout);
        bcl.u.addClass(loginErrorModal, "tingle-modal--visible");
        setTimeout(function () {
          bcl.cookie.remove("login-token", "/");
          bcl.cookie.remove("bhg-ciam-user", "/");
          bcl.cookie.remove("ROCP_token", "/");
          bcl.cookie.remove("ROCP_idToken", "/");
          bcl.cookie.remove(bcl.contextHub.props.lasukmybErrorCookie, "/");
          WIN.location.href = logoutUrl;
        }, 3000);
      }
    }
  }

  const user = bcl.u.getContextHubUser();
  if (!user) {
    sessionStorage.removeItem(bcl.contextHub.props.nameSessionStorage + bcl.contextHub.props.nameProfile);
    bcl.contextHub.props.stores[bcl.contextHub.props.nameProfile] = null;
    bcl.contextHub.init();
    bcl.contextHub.callWhenReady(callWhenReady, bcl.contextHub.props.nameProfile);
  } else {
    if (callWhenReady && typeof callWhenReady === "function") {
      callWhenReady();
    }
  }
};

//----------------------------------------------------------------//

const elementProto = window.Element && window.Element.prototype;

const matchesFn = elementProto && (elementProto.matches || elementProto.webkitMatchesSelector || elementProto.mozMatchesSelector || elementProto.msMatchesSelector || elementProto.oMatchesSelector);

bcl.u.closest = function (el, selector) {
  if (!el || !selector || !matchesFn) {
    return null;
  }

  let parent = el.parentElement;

  while (parent) {
    if (matchesFn.call(parent, selector)) {
      return parent;
    }
    parent = parent.parentElement;
  }

  return null;
};
//----------------------------------------------------------------//

bcl.u.computeScript = function (elem) {
  if (!elem) {
    return;
  }

  try {
    const scripts = elem.getElementsByTagName("script");
    for (let i = 0; i < scripts.length; i++) {
      const script = scripts[i];
      const newScript = DOC.createElement("script");

      if (script.src) {
        newScript.src = script.src;
        HEAD.appendChild(newScript);
      } else {
        newScript.text = script.innerHTML;
        HEAD.appendChild(newScript);
      }
    }
  } catch (error) {
    console.error("Error executing modal scripts:", error);
  }
};

//----------------------------------------------------------------//

bcl.u.containsClass = function ($el, className) {
  if (!$el) {
    return false;
  }
  const cl = $el.classList;
  if (cl) {
    return cl.contains(className);
  }
  return new RegExp("(^| )" + className + "( |$)", "gi").test($el.className);
};

//----------------------------------------------------------------//

bcl.u.copyAllClass = function ($el, $copy) {
  if (!$el || !$copy) {
    return;
  }
  $copy.className = $el.className;
};

//----------------------------------------------------------------//
//--------------------------- D ---------------------------//
//----------------------------------------------------------------//

bcl.u.debounce = (func, wait, immediate = false) => {
  let timeout;

  return (...args) => {
    const callNow = immediate && !timeout;

    clearTimeout(timeout);
    timeout = setTimeout(() => {
      timeout = null;
      if (!immediate) {
        func(...args);
      }
    }, wait);

    if (callNow) {
      func(...args);
    }
  };
};

//----------------------------------------------------------------//

bcl.u.decodeHTML = function (html) {
  const txt = DOC.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
};

//----------------------------------------------------------------//

bcl.u.deepExtend = function (out = {}, ...sources) {
  for (let s = 0; s < sources.length; s++) {
    const obj = sources[s];
    if (!obj) {
      continue;
    }

    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const value = obj[key];
        if (typeof value === "object" && value !== null) {
          out[key] = bcl.u.deepExtend(out[key] || {}, value);
        } else {
          out[key] = value;
        }
      }
    }
  }

  return out;
};

//----------------------------------------------------------------//

bcl.u.docReady = function (callback, skipEvent) {
  if (DOC.readyState !== "loading") {
    if (bcl.load) {
      callback();
    } else {
      bcl.preInit.push(callback);
    }
  } else {
    DOC.addEventListener("DOMContentLoaded", function () {
      callback();
    });
  }

  if (!skipEvent && !bcl.editMode) {
    DOC.addEventListener("modal-open", function (elem) {
      callback(elem.detail);
    });
    DOC.addEventListener("ajax-executed", function (elem) {
      callback(elem.detail);
    });
  }
};

//----------------------------------------------------------------//
//--------------------------- E ---------------------------//
//----------------------------------------------------------------//

bcl.u.executeFunctionByName = function (functionName, context, ...args) {
  const namespaces = functionName.split(".");
  const func = namespaces.pop();
  for (let i = 0; i < namespaces.length; i++) {
    context = context[namespaces[i]];
  }
  if (context?.[func]) {
    return context[func](...args);
  }
};

//----------------------------------------------------------------//
//--------------------------- F ---------------------------//
//----------------------------------------------------------------//

bcl.u.findClosestNodeWithClass = function (startNode, targetClass) {
  const insideNode = startNode.closest("." + targetClass);
  if (insideNode) {
    return insideNode;
  }

  let currentNode = startNode.parentElement;
  while (currentNode !== null) {
    if (currentNode.classList.contains(targetClass)) {
      return currentNode;
    }
    currentNode = currentNode.parentElement;
  }

  return null;
};

//----------------------------------------------------------------//

bcl.u.findLowestCommonAncestor = function (nodes) {
  if (!nodes || nodes.length === 0) {
    return null;
  }
  let commonAncestor = nodes[0];
  while (commonAncestor.parentNode) {
    if (nodes.every((node) => commonAncestor.contains(node))) {
      return commonAncestor;
    }
    commonAncestor = commonAncestor.parentNode;
  }
  return null;
};

//----------------------------------------------------------------//

bcl.u.forEach = function ($elements, callback) {
  if (!$elements || !callback) {
    return;
  }
  // eslint-disable-next-line no-bitwise
  const len = $elements.length >>> 0;
  for (let i = 0; i < len; i++) {
    callback($elements[i], i);
  }
};

//----------------------------------------------------------------//

bcl.u.formatDate = function (date) {
  if (!date) {
    return "";
  }

  const d = new Date(date);
  const year = d.getFullYear();

  let month = "" + (d.getMonth() + 1);
  let day = "" + d.getDate();

  if (month.length < 2) {
    month = "0" + month;
  }
  if (day.length < 2) {
    day = "0" + day;
  }

  return [year, month, day].join("-");
};

//----------------------------------------------------------------//

bcl.u.formatPriceDecimals = function (obj, basePrice = false) {
  if (!obj) {
    return;
  }
  obj = basePrice ? obj?.base : obj?.total;

  const priceObj = obj.converted || obj;
  const value = bcl.u.calculateDecimalsByExponent(priceObj.value, priceObj.exponent);
  return Math.round(value);
};

//----------------------------------------------------------------//
//--------------------------- G ---------------------------//
//----------------------------------------------------------------//

bcl.u.getAllUrlParamsFromUrl = function (url) {
  let queryString = url ? url.split("?")[1] : WIN.location.search.slice(1);
  const obj = {};

  if (!queryString) {
    return obj;
  }

  queryString = queryString.split("#")[0];
  const arr = queryString.split("&");

  for (let i = 0; i < arr.length; i++) {
    const a = arr[i].split("=");
    let paramName = a[0];
    let paramValue = typeof a[1] === "undefined" ? true : a[1];
    paramName = paramName.toLowerCase();
    if (typeof paramValue === "string") {
      paramValue = paramValue.toLowerCase();
    }

    if (paramName.match(/\[(\d+)?\]$/)) {
      const key = paramName.replace(/\[(\d+)?\]/, "");
      if (!obj[key]) {
        obj[key] = [];
      }

      if (paramName.match(/\[\d+\]$/)) {
        const index = /\[(\d+)\]/.exec(paramName)[1];
        obj[key][index] = paramValue;
      } else {
        obj[key].push(paramValue);
      }
    } else {
      if (!obj[paramName]) {
        obj[paramName] = paramValue;
      } else if (obj[paramName] && typeof obj[paramName] === "string") {
        obj[paramName] = [obj[paramName]];
        obj[paramName].push(paramValue);
      } else {
        obj[paramName].push(paramValue);
      }
    }
  }

  return obj;
};

//----------------------------------------------------------------//

bcl.u.getbase64DecodedUrl = function (str) {
  try {
    if (typeof str !== "string") {
      return str;
    }

    str = str.trim();
    const base64Regex = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
    if (!base64Regex.test(str)) {
      return str;
    }

    const decoded = atob(str);
    if (!decoded) {
      return str;
    }
    return decoded;
  } catch (e) {
    return str;
  }
};

//----------------------------------------------------------------//

bcl.u.getContextHubUser = function () {
  let user = null;
  if (typeof bcl.contextHub !== "undefined") {
    const profile = bcl.contextHub.get("profile");
    const profileUser = profile?.user;
    const hasProfileUser = profileUser && Object.keys(profileUser).length > 0;
    if (hasProfileUser && ((profileUser.federationId && bcl.cookie.get(bcl.contextHub.props.lasukmybCookie) === "1") || (!profileUser.federationId && bcl.cookie.get(bcl.contextHub.props.lasukmybCookie) !== "1"))) {
      user = profile.user;
    } else if (bcl.cookie.get(bcl.contextHub.props.lasukmybCookie) === "1") {
      return null;
    }
  }
  return user;
};

//----------------------------------------------------------------//

bcl.u.getCountryCode = function () {
  let code = DOC.body.dataset.countrycode || "es";

  if (typeof bcl.contextHub !== "undefined") {
    let profile = bcl.contextHub.get("profile");

    if (profile) {
      profile = bcl.contextHub.getItem(profile, "country_code");
      if (profile) {
        code = profile;
      }
    }
  }

  if (crossOriginURLS.test(WIN.location.hostname) && WIN.utag_data?.user_country_name) {
    code = WIN.utag_data.user_country_name;
  }

  return code.toLowerCase();
};

//----------------------------------------------------------------//

bcl.u.getCurrency = function (code) {
  const obj = {
    AED: "د.إ",
    AWG: "ƒ",
    BRL: "R$",
    CAD: "C$",
    CHF: "CHF",
    CLP: "$",
    COP: "$",
    CRC: "₡",
    CUP: "₱",
    CZK: "Kč",
    DKK: "kr",
    DOP: "RD$",
    EGP: "£",
    EUR: "€",
    GBP: "£",
    GTQ: "Q",
    HUF: "Ft",
    LKR: "Rs",
    MAD: "MAD",
    MXN: "MXN$",
    NIO: "C$",
    NOK: "kr",
    PEN: "S/.",
    PLN: "zł",
    RUB: "₽",
    SEK: "kr",
    TRY: "₺‎",
    UYU: "$U",
    USD: "$",
    VES: "Bs",
    SAR: "SAR",
    OMR: "﷼",
    KWD: " د.ك",
    QAR: "QR",
    ILS: "₪",
    BHD: "BD",
    RON: "RON",
    ARS: "ARS$",
    IDR: "Rp",
    AUD: "$",
    INR: "₹",
    CNY: "¥",
    THB: "฿",
    CVE: "Esc$",
  };

  if (!code) {
    code = bcl.s.currency.props.currency.current;
  }

  return code ? obj[code] || "" : "";
};

//----------------------------------------------------------------//

bcl.u.getDates = function (data) {
  if (data.startDate && data.endDate) {
    return {
      arrive: data.startDate.split("T")[0],
      depart: data.endDate.split("T")[0],
    };
  }
  return {};
};

//----------------------------------------------------------------//

bcl.u.getInData = function (obj, path) {
  if (!obj || !path) {
    return null;
  }

  let current = obj;
  path = path.split(".");
  for (let i = 0; i < path.length; i++) {
    if (!current[path[i]] && isNaN(current[path[i]])) {
      return null;
    }
    current = current[path[i]];
  }
  return current;
};

//----------------------------------------------------------------//

bcl.u.getKeyByValue = function (obj, val) {
  return Object.keys(obj).find((key) => obj[key] === val);
};

//----------------------------------------------------------------//

bcl.u.getLongCacheKey = function () {
  if (bcl.u._lcKey != null) {
    return bcl.u._lcKey;
  }

  const prefix = ".lc-";
  const suffix = "-lc.min.js";
  const suffixAlt = "-lc.js";

  const resources = performance.getEntriesByType("resource");
  let url = "";
  let usedSuffix = suffix;

  for (let i = 0; i < resources.length; i++) {
    const name = resources[i].name;
    if (name && name.indexOf(prefix) !== -1 && name.indexOf(suffix) !== -1) {
      url = name;
      usedSuffix = suffix;
      break;
    }
  }

  if (!url) {
    for (let i = 0; i < resources.length; i++) {
      const name = resources[i].name;
      if (name && name.indexOf(prefix) !== -1 && name.indexOf(suffixAlt) !== -1) {
        url = name;
        usedSuffix = suffixAlt;
        break;
      }
    }
  }

  if (!url) {
    bcl.u._lcKey = "";
    return "";
  }

  const startIndex = url.indexOf(prefix);
  const endIndex = url.indexOf(usedSuffix, startIndex);

  if (startIndex === -1 || endIndex === -1) {
    console.error("Failed to extract cache ID from URL.");
    bcl.u._lcKey = "";
    return "";
  }

  const cacheKey = url.substring(startIndex + prefix.length, endIndex);
  bcl.u._lcKey = cacheKey || "";
  return bcl.u._lcKey;
};

//----------------------------------------------------------------//

bcl.u.getNormalizedDate = function (date) {
  let output = new Date();

  if (date) {
    if (typeof date === "string") {
      if (date.indexOf("T") < 0 && date.indexOf(" ") < 0) {
        output = new Date(date + "T12:00:00.000Z");
      } else {
        output = new Date(date);
      }
    } else if (typeof date === "number") {
      output = new Date(date);
    } else if (typeof date === "object") {
      output = date;
    }
  }

  output.setHours(12, 0, 0);
  output.setMilliseconds(0);
  return output;
};

//----------------------------------------------------------------//

bcl.u.getOffset = function (el) {
  const rect = el.getBoundingClientRect();
  const sx = WIN.scrollX || DOC_EL.scrollLeft;
  const sy = WIN.scrollY || DOC_EL.scrollTop;

  return {
    left: rect.left + sx,
    top: rect.top + sy,
    right: rect.left + sx + el.offsetWidth,
    bottom: rect.top + sy + el.offsetHeight,
  };
};

//----------------------------------------------------------------//

bcl.u.getPageLanguage = function () {
  return DOC_EL.getAttribute("lang").toLowerCase();
};

//----------------------------------------------------------------//

bcl.u.getParameterByName = function (name, url) {
  if (!url) {
    url = WIN.location.href;
  }
  name = name.replace(/[\[\]]/g, "\\$&");
  const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
  const results = regex.exec(url);
  if (!results) {
    return null;
  }
  if (!results[2]) {
    return "";
  }
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

//----------------------------------------------------------------//

bcl.u.getParent = function ($child, $class) {
  while ($child != null && !bcl.u.containsClass($child, $class)) {
    $child = $child.parentElement;
  }
  return $child;
};

//----------------------------------------------------------------//

bcl.u.getSelectedOption = function ($el) {
  let opt;
  for (let i = 0; i < $el.options.length; i++) {
    opt = $el.options[i];
    if (opt.selected === true) {
      break;
    }
  }
  return opt;
};

//----------------------------------------------------------------//

bcl.u.getUrlParam = function ($url, $param) {
  try {
    const url = new URL($url, ORIGIN);
    return url.searchParams.get($param);
  } catch (e) {
    return null;
  }
};

//----------------------------------------------------------------//

bcl.u.goToNewTab = function (data) {
  const url = data && data.Message;
  if (!url) {
    return;
  }

  const openTarget = bcl.u.browser.isSafari() || bcl.u.browser.isEdge() || bcl.u.mobile.webView() || bcl.u.browser.isFirefox() ? "_self" : "_blank";

  window.open(url, openTarget);
};

//----------------------------------------------------------------//

bcl.u.goToWithScroll = function (obj) {
  const o = obj || {};
  const node = o.node || window;

  const top = typeof o.top === "number" ? o.top : isNaN(o.top) ? 0 : Number(o.top);
  const left = typeof o.left === "number" ? o.left : isNaN(o.left) ? 0 : Number(o.left);
  const behavior = o.behavior || "smooth";

  if (bcl.u.mobile.iOS()) {
    if (o.node) {
      if (node && typeof node.scrollTo === "function") {
        node.scrollTo(left, top);
      } else if (node) {
        node.scrollLeft = left;
        node.scrollTop = top;
      }
    } else {
      bcl.u.scrollToSmoothly(top, 1000);
    }
    return;
  }

  if (node && typeof node.scroll === "function") {
    node.scroll({ top: top, left: left, behavior: behavior });
  } else if (node && typeof node.scrollTo === "function") {
    node.scrollTo(left, top);
  } else if (node) {
    node.scrollLeft = left;
    node.scrollTop = top;
  }
};

//----------------------------------------------------------------//
//--------------------------- H ---------------------------//
//----------------------------------------------------------------//

bcl.u.hiddeElements = function ($elements, classStr) {
  if ($elements && $elements.length > 0) {
    for (let i = 0; i < $elements.length; i++) {
      bcl.u.addClass($elements[i], classStr || "hidden");
    }
  }
};

//----------------------------------------------------------------//

bcl.u.htmlToDOMElement = function (content) {
  const div = DOC.createElement("div");
  div.innerHTML = content.trim();
  return div.firstChild;
};

//----------------------------------------------------------------//
//--------------------------- I ---------------------------//
//----------------------------------------------------------------//

bcl.u.importScript = function (url, globalName) {
  return new Promise((resolve, reject) => {
    const script = DOC.createElement("script");
    script.src = url;
    script.type = "text/javascript";
    script.defer = true;

    script.onload = () => {
      if (globalName && WIN[globalName]) {
        resolve(WIN[globalName]);
      } else if (!globalName) {
        resolve();
      } else {
        reject(new Error(`Global variable ${globalName} not found after script load.`));
      }
    };

    script.onerror = () => reject(new Error(`Failed to load script: ${url}`));
    HEAD.appendChild(script);
  });
};

//----------------------------------------------------------------//

bcl.u.includes = function (container, value) {
  return container.indexOf(value) >= 0;
};

//----------------------------------------------------------------//

bcl.u.initMybUserComponents = function () {
  const user = bcl.u.getContextHubUser();
  if (user) {
    bcl.c.header?.showModalMyBarcelo(user);
    bcl.c.mybProfile?.init(user);
  }
  bcl.c.mybLoyaltyTargeting?.init(user);
};

//----------------------------------------------------------------//

bcl.u.isDescendant = function (parent, child) {
  let node = child.parentNode;
  while (node != null) {
    if (node === parent) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
};

//----------------------------------------------------------------//

bcl.u.isElementInView = function (element, fullyInView) {
  if (element) {
    const pageTop = WIN.scrollY;
    const pageBottom = pageTop + WIN.innerHeight;

    const elementTop = element.getBoundingClientRect().top + pageTop;
    const elementBottom = elementTop + element.offsetHeight;

    if (fullyInView === true) {
      return pageTop < elementTop && pageBottom > elementBottom;
    }
    return elementTop <= pageBottom && elementBottom >= pageTop;
  }
};

//----------------------------------------------------------------//

bcl.u.isInViewport = function ($elem) {
  if (!$elem) {
    return false;
  }
  const bounding = $elem.getBoundingClientRect();
  return bounding.top - WIN.innerHeight <= 0 || bounding.bottom <= (WIN.innerHeight || DOC_EL.clientHeight);
};

//----------------------------------------------------------------//

bcl.u.isPhoneField = function (field) {
  return field.type === "tel" && bcl.u.containsClass(field, bcl.s.intlTelInput.props.cssSelector);
};

//----------------------------------------------------------------//
//--------------------------- L ---------------------------//
//----------------------------------------------------------------//

bcl.u.listAddClass = function ($elements, classStr) {
  if ($elements && $elements.length > 0) {
    for (let i = 0; i < $elements.length; i++) {
      if (Array.isArray(classStr)) {
        bcl.u.forEach(classStr, function (className) {
          bcl.u.addClass($elements[i], className);
        });
      } else {
        bcl.u.addClass($elements[i], classStr);
      }
    }
  }
};

//----------------------------------------------------------------//

bcl.u.listRemoveClass = function ($elements, classStr) {
  if ($elements && $elements.length > 0) {
    for (let i = 0; i < $elements.length; i++) {
      if (Array.isArray(classStr)) {
        bcl.u.forEach(classStr, function (className) {
          bcl.u.removeClass($elements[i], className);
        });
      } else {
        bcl.u.removeClass($elements[i], classStr);
      }
    }
  }
};

//----------------------------------------------------------------//

bcl.u.loadAsyncData = function () {
  const domAsyncLoad = DOC.querySelectorAll("[data-async-load]");
  if (!domAsyncLoad.length) {
    return;
  }

  for (let i = 0; i < domAsyncLoad.length; i++) {
    const $el = domAsyncLoad[i];

    const callback = $el.getAttribute("data-async-callback");
    const url = $el.getAttribute("data-async-load");
    const post = $el.getAttribute("data-async-type");
    const noDelete = $el.getAttribute("data-not-delete");
    const spinner = $el.getAttribute("data-spinner");
    const noRemoveAttribute = $el.getAttribute("data-no-remove-attribute");

    if (spinner) {
      bcl.u.addSpinner($el);
    }

    if (post && post === "POST") {
      bcl.ajax.postRequest({
        url: url,
        callback: callback,
        itemCallback: $el,
      });
    } else {
      bcl.ajax.getRequest(noDelete ? null : $el, url, callback, $el);
    }

    if (!noRemoveAttribute) {
      $el.removeAttribute("data-async-load");
      $el.removeAttribute("data-async-callback");
      $el.removeAttribute("data-async-type");
      $el.removeAttribute("data-not-delete");
      $el.removeAttribute("data-spinner");
    }
  }
};

//----------------------------------------------------------------//

bcl.u.loadExternalStyle = function (url) {
  const cache = bcl.u._externalStylePromises;
  if (cache[url]) {
    return cache[url];
  }

  cache[url] = new Promise(function (resolve, reject) {
    try {
      const existing = DOC.querySelector('link[data-external-style="' + url + '"]');
      if (existing) {
        resolve(true);
        return;
      }

      const link = DOC.createElement("link");
      link.rel = "stylesheet";
      link.href = url;
      link.setAttribute("data-external-style", url);

      link.addEventListener(
        "load",
        function () {
          resolve(true);
        },
        { once: true },
      );

      link.addEventListener(
        "error",
        function () {
          reject(new Error("Failed to load external stylesheet: " + url));
        },
        { once: true },
      );

      HEAD.appendChild(link);
    } catch (error) {
      reject(error);
    }
  });

  return cache[url];
};

//----------------------------------------------------------------//

bcl.u.loadScript = function (obj) {
  return new Promise(function (resolve, reject) {
    const scripts = DOC.getElementsByTagName("script");
    const target = obj && obj.src ? obj.src : "";

    let existingScript = null;
    if (target) {
      for (let i = 0; i < scripts.length; i++) {
        const s = scripts[i];
        if (s.src === target || s.src === target.replace(".js", "") || s.src.replace(/\.js$/i, "") === target.replace(/\.js$/i, "")) {
          existingScript = s;
          break;
        }
      }
    }

    const onSuccess = function () {
      if (obj && typeof obj.callback === "function") {
        obj.callback(true);
      }
      resolve(true);
    };

    const onError = function (error) {
      if (obj && typeof obj.callback === "function") {
        obj.callback(false, error);
      }
      reject(error);
    };

    if (existingScript) {
      onSuccess();
      return;
    }

    const js = DOC.createElement("script");

    js.src = obj.src.includes("external=true") ? obj.src : obj.src.replace(".js", `.lc-${bcl.u.getLongCacheKey()}-lc.min.js`);
    js.async = true;

    if (obj.crossOrigin) {
      js.crossOrigin = "anonymous";
    }
    if (obj.id) {
      js.id = obj.id;
    }
    if (obj.type) {
      js.type = obj.type;
    }

    js.addEventListener(
      "load",
      function () {
        onSuccess();
      },
      { once: true },
    );

    js.addEventListener(
      "error",
      function () {
        onError(new Error("Failed to load script " + obj.src));
      },
      { once: true },
    );

    if (crossOriginURLS.test(WIN.location.hostname)) {
      js.src = js.src.replace(WIN.location.hostname, "www.barcelo.com");
    }

    HEAD.appendChild(js);
  });
};

//----------------------------------------------------------------//
//--------------------------- P ---------------------------//
//----------------------------------------------------------------//

bcl.u.runPreInit = function () {
  if (bcl.u.preInitRunning) {
    return;
  }
  bcl.u.preInitRunning = true;
  while (bcl.preInit.length) {
    const callback = bcl.preInit.shift();
    try {
      callback();
    } catch (error) {
      console.error("preInit callback failed:", error);
    }
  }
  bcl.u.preInitRunning = false;
};

bcl.u.preInit = function () {
  bcl.u.runPreInit();

  if (!bcl.u.preInitReady) {
    bcl.u.preInitReady = true;

    const nativePush = Array.prototype.push;
    bcl.preInit.push = function (...callbacks) {
      const length = nativePush.apply(this, callbacks);
      if (!bcl.u.preInitFlushScheduled) {
        bcl.u.preInitFlushScheduled = true;
        setTimeout(function () {
          bcl.u.preInitFlushScheduled = false;
          bcl.u.runPreInit();
        }, 0);
      }
      return length;
    };
    bcl.u.triggerEvent(WIN, "preInitLoaded");
  }
};

//----------------------------------------------------------------//

bcl.u.pushField = function (array, serialized, encode, name, value) {
  if (!array) {
    if (serialized[name]) {
      const valueItem = serialized[name];
      if (!Array.isArray(serialized[name])) {
        serialized[name] = [valueItem];
      }
      serialized[name].push(value);
    } else {
      serialized[name] = value;
    }
    if (serialized["keys"].indexOf(name) < 0) {
      serialized["keys"].push(name);
    }
  } else if (encode) {
    serialized.push(encodeURIComponent(name) + "=" + encodeURIComponent(value));
  } else {
    serialized.push(name + "=" + value);
  }
};

//----------------------------------------------------------------//

bcl.u.putInBold = function (string, item) {
  if (!item || !string) {
    return { value: string, matched: false };
  }

  const cItem = item.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  const cString = string.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

  const reg = "(" + cItem + ")(?![^<]*>|[^<>]*</)";
  const regex = new RegExp(reg, "i");
  const match = cString.match(regex);

  if (!match) {
    return { value: string, matched: false };
  }

  const matchStartPosition = match.index;
  const matchEndPosition = matchStartPosition + cString.match(regex)[0].toString().length;

  const originalTextFoundByRegex = string.substring(matchStartPosition, matchEndPosition);
  const firstPart = bcl.u.putInBold(string.substring(0, matchStartPosition), item);
  const secondPart = bcl.u.putInBold(string.substring(matchEndPosition, string.length), item);

  const value = firstPart.value + "<strong>" + originalTextFoundByRegex + "</strong>" + secondPart.value;

  return {
    value: value,
    matched: !!match.length || firstPart.value || secondPart.value,
  };
};

//----------------------------------------------------------------//
//--------------------------- R ---------------------------//
//----------------------------------------------------------------//

bcl.u.redirectForm = function (data, container) {
  const submitForm = container.querySelector(".submit-form-JS");
  if (submitForm && data.authenticate) {
    submitForm.elements.RelayState.value = data.Message + "&redirectOnError=1";
    const submitButton = container.querySelector(".submit-button-JS");
    if (submitButton) {
      submitButton.click();
    }
  }
};

//----------------------------------------------------------------//

bcl.u.removeAccents = function (value) {
  return value ? value.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : "";
};

//----------------------------------------------------------------//

bcl.u.removeAllClass = function ($el) {
  if ($el) {
    $el.className = "";
  }
};

//----------------------------------------------------------------//

bcl.u.removeBhgLoading = function ($container) {
  if (!$container) {
    $container = DOC.body;
  }

  $container.removeAttribute("style");
  bcl.u.removeClass($container, "bhg-loading-wrap");

  const mainLoader = $container.querySelector(".bhg-loading:not(.JS-translation-loader)");
  if (mainLoader) {
    bcl.u.removeClass(mainLoader, "mod--loading-active");
  }

  $container.classList.remove("mod--bhg-loading");

  setTimeout(function () {
    const loaders = $container.querySelectorAll(".bhg-loading:not(.JS-translation-loader)");
    const parentsDiv = [];

    if (loaders && loaders.length > 0) {
      for (let i = 0; i < loaders.length; i++) {
        const load = loaders[i];
        if (load.parentElement && load.parentElement.nodeName === "DIV" && load.parentElement.classList.length === 0) {
          parentsDiv.push(load.parentElement);
        }
      }
    }

    bcl.u.removeElements(parentsDiv && parentsDiv.length ? parentsDiv : loaders);
  }, 300);
};

//----------------------------------------------------------------//

bcl.u.removeClass = function ($el, className) {
  if (!$el || !className) {
    return;
  }

  if (Array.isArray($el)) {
    for (let i = 0; i < $el.length; i++) {
      bcl.u.removeClass($el[i], className);
    }
    return;
  }

  const cl = $el.classList;
  if (cl) {
    cl.remove(className);
  } else if ($el.className) {
    $el.className = $el.className.replace(new RegExp("(^|\\b)" + className.split(" ").join("|") + "(\\b|$)", "gi"), " ");
  }
};

//----------------------------------------------------------------//

bcl.u.removeClassWithRegex = function ($el, regEx) {
  if (!$el || !regEx) {
    return false;
  }

  const classList = $el.classList || ($el.className && $el.className.split(" "));
  if (!classList) {
    return false;
  }

  let classToRemove = false;
  classList.forEach((cls) => {
    if (regEx.test(cls)) {
      bcl.u.removeClass($el, cls);
      classToRemove = true;
    }
  });

  return classToRemove;
};

//----------------------------------------------------------------//

bcl.u.removeElements = function ($elements) {
  if ($elements && $elements.length > 0) {
    for (let i = 0; i < $elements.length; i++) {
      const n = $elements[i];
      n && n.parentNode && n.parentNode.removeChild(n);
    }
  }
};

//----------------------------------------------------------------//

bcl.u.removeSpinner = function ($container) {
  bcl.u.removeClass($container, "loading-dots");
};

//----------------------------------------------------------------//

bcl.u.removeUrlParameter = function (name, url) {
  if (!url) {
    url = WIN.location.href;
  }
  if (url.indexOf("?") === -1) {
    return "";
  }

  const queryString = url.split("?")[1].split("&");
  if (queryString.length > 1) {
    let queryParams = "";
    for (let i = 0; i < queryString.length; i++) {
      let key = "";
      if (queryString[i].indexOf("=") > -1) {
        key = queryString[i].split("=")[0];
        if (key !== name) {
          queryParams = queryParams.length > 0 ? queryParams + "&" + queryString[i] : queryString[i];
        }
      }
    }
    return queryParams;
  }
  return "";
};

//----------------------------------------------------------------//

bcl.u.replaceImage = function (target, original, next) {
  const baseElement = typeof target === "string" ? document.querySelector(target) : target;

  if (!(baseElement instanceof Element)) {
    return false;
  }

  const container = baseElement.matches(".cmp-image, [data-cmp-src]") ? baseElement : baseElement.closest(".cmp-image, [data-cmp-src]") || baseElement.querySelector(".cmp-image, [data-cmp-src]");

  const currentCmpSrc = (container?.getAttribute("data-cmp-src") || "").replace(/&amp;/g, "&");
  const currentAsset = container?.getAttribute("data-asset") || "";
  const currentImg = container?.querySelector("img[data-barcelo-image='true']");

  if (!(container instanceof Element) || !(currentImg instanceof HTMLImageElement) || !currentCmpSrc || !currentAsset) {
    return false;
  }

  if (original?.src && !currentCmpSrc.includes(`/${original.src}?`)) {
    return false;
  }

  if (original?.path && currentAsset !== original.path) {
    return false;
  }

  const [baseSrc, query = ""] = currentCmpSrc.split("?");
  const lastSlashIndex = baseSrc.lastIndexOf("/");

  if (lastSlashIndex === -1) {
    return false;
  }

  const newCmpSrc = `${baseSrc.slice(0, lastSlashIndex + 1)}${next.src}?${query}`;

  if (newCmpSrc === currentCmpSrc) {
    return false;
  }

  const newContainer = container.cloneNode(false);
  const newImg = currentImg.cloneNode(false);

  newContainer.setAttribute("data-cmp-src", newCmpSrc);
  newContainer.setAttribute("data-asset", next?.path || currentAsset);
  newContainer.setAttribute("data-is-dm", "true");

  newImg.removeAttribute("src");
  newImg.removeAttribute("srcset");
  newImg.removeAttribute("width");
  newImg.removeAttribute("height");
  newImg.removeAttribute("data-optimized");
  newImg.loading = "lazy";
  newImg.className = newImg.className
    .replace(/\bloadPosition-\S+\b/g, "")
    .trim()
    .replace(/\s+/g, " ");

  newContainer.appendChild(newImg);
  container.replaceWith(newContainer);

  return true;
};

//----------------------------------------------------------------//

bcl.u.replaceLastCharacterWithSelector = function (url, selector) {
  return url.slice(0, -1) + "--" + selector + "/";
};

//----------------------------------------------------------------//

bcl.u.resetImage = function ($imgContainer) {
  if ($imgContainer) {
    const $img = $imgContainer.getElementsByTagName("img");
    if (!$img || $img.length === 0) {
      return;
    }

    const $noScript = DOC.createElement("noscript");
    $noScript.setAttribute("data-cmp-hook-image", "noscript");
    bcl.u.wrap($img[0], $noScript);

    $img[0].setAttribute("src", $imgContainer.getAttribute("data-asset"));
    $img[0].setAttribute("data-cmp-hook-image", "image");

    $imgContainer.setAttribute("data-cmp-is", "image");
  }
};

//----------------------------------------------------------------//

bcl.u.resize = function (callback, node = WIN) {
  node.addEventListener("resize", callback);
};

//----------------------------------------------------------------//
//--------------------------- S ---------------------------//
//----------------------------------------------------------------//

bcl.u.scrollToSmoothly = function (pos, time) {
  if (typeof pos !== "number") {
    pos = parseFloat(pos);
  }
  if (isNaN(pos)) {
    console.warn("Position must be a number or a numeric String.");
    throw new Error("Position must be a number");
  }
  if (pos < 0 || time < 0) {
    return;
  }

  const currentPos = WIN.scrollY || DOC_EL.scrollTop || WIN.screenTop;
  let start = null;
  time = time || 500;

  WIN.requestAnimationFrame(function step(currentTime) {
    start = !start ? currentTime : start;
    let progress;

    if (currentPos < pos) {
      progress = currentTime - start;
      WIN.scrollTo(0, ((pos - currentPos) * progress) / time + currentPos);
      if (progress < time) {
        WIN.requestAnimationFrame(step);
      } else {
        WIN.scrollTo(0, pos);
      }
    } else {
      progress = currentTime - start;
      WIN.scrollTo(0, currentPos - ((currentPos - pos) * progress) / time);
      if (progress < time) {
        WIN.requestAnimationFrame(step);
      } else {
        WIN.scrollTo(0, pos);
      }
    }
  });
};

//----------------------------------------------------------------//

bcl.u.serializeForm = function (form, array, encode) {
  let serialized = {};
  serialized.keys = [];

  if (array) {
    serialized = [];
    serialized["keys"] = [];
  }

  for (let i = 0; i < form.elements.length; i++) {
    const field = form.elements[i];
    let name = "";
    let value = "";

    if ((!field.name && !field.id) || field.disabled || field.type === "file" || field.type === "reset" || field.type === "submit" || field.type === "button") {
      continue;
    }

    if (field.type === "select-multiple") {
      for (let n = 0; n < field.options.length; n++) {
        if (!field.options[n].selected) {
          continue;
        }
        name = field.name || field.id;
        value = field.options[n].value;
      }
    } else if (bcl.u.isPhoneField(field)) {
      name = field.name || field.id;
      value = bcl.s.intlTelInput.getPhone(field);
    } else if ((field.type !== "checkbox" && field.type !== "radio" && field.value) || field.checked) {
      name = field.name || field.id;
      value = field.value;
    }

    if ((field.required && !field.validity.valid) || bcl.u.containsClass(form, bcl.s.form.props.classErrorValidationForm)) {
      return false;
    }

    bcl.u.pushField(array, serialized, encode, name, value);

    if (bcl.u.isPhoneField(field)) {
      const dialName = name + "-dial";
      const dialValue = WIN.intlTelInputGlobals.getInstance(field).selectedCountryData.dialCode;
      bcl.u.pushField(array, serialized, encode, dialName, dialValue);
    }
  }

  if (array) {
    return serialized.join("&");
  }

  return serialized;
};

//----------------------------------------------------------------//

bcl.u.serializeObject = function (obj) {
  const pairs = [];
  for (const prop in obj) {
    if (!Object.prototype.hasOwnProperty.call(obj, prop)) {
      continue;
    }
    if (Object.prototype.toString.call(obj[prop]) == "[object Object]") {
      pairs.push(bcl.u.serializeObject(obj[prop]));
      continue;
    }
    pairs.push(prop + "=" + obj[prop]);
  }
  return pairs.join("&");
};

//----------------------------------------------------------------//

bcl.u.setButtonOfferCard = function ($article, data) {
  const buttons = $article && $article.getElementsByClassName("button-JS");
  if (!buttons || !buttons.length) {
    return true;
  }

  const hasClass = function (el, cls) {
    return !!(el && el.classList && el.classList.contains(cls)) || bcl.u.containsClass(el, cls);
  };

  for (let i = 0; i < buttons.length; i++) {
    const $button = buttons[i];

    $button.addEventListener("click", function (e) {
      const utagData = window.utag_data;
      const fastbooking = bcl.c.fastbooking;
      const discount = fastbooking && fastbooking.discount;
      const calendar = fastbooking && fastbooking.calendar;

      e.stopPropagation();

      if (hasClass($button, "mod--cta-disabled")) {
        return;
      }

      if (fastbooking && fastbooking.props) {
        fastbooking.props.redirectToBEDirectly = data?.redirectToBEDirectly ?? fastbooking?.props?.redirectToBEDirectly;
        if (data && data.uspCampaignShortName) {
          fastbooking.props.uspCampaignShortName = data.uspCampaignShortName;
        }
      }

      fastbooking && fastbooking.showFB && fastbooking.showFB();

      if (bcl.u.utag.isEnabled()) {
        try {
          const offerIdCampaign = $article.getAttribute("data-offer-id-campaign");
          const campaignID = (offerIdCampaign && offerIdCampaign.split("/").pop()) || data.offer.name;

          bcl.u.utag.push({
            ecommerce_action: "promo_click",
            ecommerce_action_field_list_gtag: utagData && utagData.ecommerce_action_field_list_gtag,
            ecommerce_action_gtag: "select_promo_content",
            promo_id: [$article.getAttribute("data-offer-id")],
            promo_creative: [utagData && utagData.ecommerce_action_field_list_gtag],
            promo_value: [$article.getAttribute("data-offer-value")],
            promo_name: [campaignID],
            promo_value_type: [$article.getAttribute("data-offer-type")],
            promo_position: [String((parseInt($article.dataset.index || 0) || 0) + 1)],
          });
        } catch (err) {
          console.warn("Data push error", err);
        }
      }

      let selector;
      let redirect = false;

      if (hasClass($button, "coupon-button-JS")) {
        discount && discount.addPromocode && discount.addPromocode($button.dataset.value, false);
      } else if (hasClass($button, "coupon-campaign-group-button-JS")) {
        discount && discount.add && discount.add($button.dataset.value, discount.props.attrCampaignPromo, $button.dataset.value, $button.dataset.selectorcode);
        selector = calendar?.props?.calendarCampaignGroupSelector;
        redirect = true;
      } else {
        selector = "calendarpromo";
        redirect = true;
      }

      const obj = {
        destination: {
          selector: selector,
          code: data.offer.id_category,
          id: data.info.hotelId,
          data: {
            adultsOnly: data.info.is_hotel_adults_only,
            minAdultsAge: data.info.minimum_age_for_adults,
            specialDiscounts: data.info.specialDiscounts,
          },
          label: data.info.search_title || data.info.name,
          type: "hotel",
        },
        offer: data.offer,
        redirect: redirect,
      };

      if (calendar && calendar.props) {
        calendar.props.showOnlyCampaignPrices = data.offer.campaignProperties.blockedDates === "true" || data.offer.campaignProperties.blockedDates === true;
      }

      const promoBtn = document.body.getElementsByClassName("coupon-cta-JS");
      if (promoBtn && promoBtn.length > 0) {
        promoBtn[0].click();
      }

      fastbooking && fastbooking.processBooking && fastbooking.processBooking(obj);

      if (fastbooking && fastbooking.isCampaignGroup && fastbooking.isCampaignGroup()) {
        const campaignDateStart = bcl.u.getNormalizedDate(obj.offer.travel_start);
        calendar && calendar.goToDate && calendar.goToDate(campaignDateStart, { openOnReady: true });
      }
    });
  }

  return true;
};

//----------------------------------------------------------------//

bcl.u.setDateInUtagData = function (utagobj, startDate, endDate) {
  const sY = +startDate.slice(0, 4);
  const sM = (+startDate.slice(5, 7) || 1) - 1;
  const sD = +startDate.slice(8, 10);

  const eY = +endDate.slice(0, 4);
  const eM = (+endDate.slice(5, 7) || 1) - 1;
  const eD = +endDate.slice(8, 10);

  const today = new Date();
  const sDate = new Date(sY, sM, sD);
  const eDate = new Date(eY, eM, eD);

  const DAY_MS = 86400000;
  utagobj.search_advance_days = "" + (Math.trunc((sDate.getTime() - today.getTime()) / DAY_MS) + 1);
  utagobj.search_nights = "" + Math.trunc((eDate.getTime() - sDate.getTime()) / DAY_MS);

  utagobj.search_check_in_hyphen = startDate;
  utagobj.search_check_in_yyyymmdd = startDate.replace(/-/g, "/");
  utagobj.search_check_in_date = startDate.replace(/-/g, "");
  utagobj.search_check_in_mmddyyyy = sM + 1 + "/" + sD + "/" + sY;

  utagobj.search_check_out_hyphen = endDate;
  utagobj.search_check_out_yyyymmdd = endDate.replace(/-/g, "/");
  utagobj.search_check_out_date = endDate.replace(/-/g, "");
  utagobj.search_check_out_mmddyyyy = eM + 1 + "/" + eD + "/" + eY;

  bcl.u.utag.add(utagobj);
};

//----------------------------------------------------------------//

bcl.u.setStyleInElement = function ($element, property, value) {
  $element.style[property] = value;
};

//----------------------------------------------------------------//

bcl.u.showDatesMessage = function (data, $el, selector) {
  const arrive = new Date(data.arrive);
  const depart = new Date(data.depart);

  const monthsArr = ($el.dataset.months || "").split(",");
  const monthFrom = monthsArr[arrive.getMonth()];
  const monthTo = monthsArr[depart.getMonth()];

  bcl.u.writeDates($el, arrive.getDate(), "." + selector + "-from-JS");

  if (arrive.getMonth() !== depart.getMonth()) {
    bcl.u.writeDates($el, arrive.getMonth(), "." + selector + "month-from-JS", true, monthFrom);
  }

  if (arrive.getFullYear() !== depart.getFullYear()) {
    bcl.u.writeDates($el, arrive.getFullYear(), "." + selector + "-year-from-JS");
  }

  bcl.u.writeDates($el, depart.getDate(), "." + selector + "-to-JS");
  bcl.u.writeDates($el, depart.getMonth(), "." + selector + "-month-to-JS", true, monthTo);
  bcl.u.writeDates($el, depart.getFullYear(), "." + selector + "-year-to-JS");
};

//----------------------------------------------------------------//

bcl.u.showElements = function ($elements, classStr) {
  if ($elements && $elements.length > 0) {
    for (let i = 0; i < $elements.length; i++) {
      bcl.u.removeClass($elements[i], classStr || "hidden");
    }
  }
};

//----------------------------------------------------------------//

const SWIPER_FULL_ONLY_CONFIG_KEYS = ["autoplay", "thumbs", "effect", "scrollbar", "mousewheel"];

const swiperConfigNeedsFullProfile = (config) => !!config && SWIPER_FULL_ONLY_CONFIG_KEYS.some((key) => Boolean(config[key]));

const swiperElementNeedsFullProfile = ($element) => $element.dataset.autoplay === "true" || $element.dataset.mousewheel === "true";

const swiperPendingElements = new WeakSet();

const pendingAsyncSwiperLoads = new WeakSet();

bcl.u.swiper = {
  changeParent: function ($element, hasMultipleColumns) {
    const sWrapper = $element.querySelector(".swiper-wrapper");

    if (!sWrapper) {
      return null;
    }

    const currentParent = sWrapper.parentElement;
    if (currentParent && currentParent.classList.contains("swiper-wrapper-overflow")) {
      if (hasMultipleColumns) {
        bcl.u.addClass(currentParent, "swiper-grid");
      }
      return sWrapper;
    }

    const wrapper = DOC.createElement("div");
    bcl.u.addClass(wrapper, "swiper-wrapper-overflow");

    if (hasMultipleColumns) {
      bcl.u.addClass(wrapper, "swiper-grid");
    }

    bcl.u.wrap(sWrapper, wrapper);
    return sWrapper;
  },

  configure: function ($element, props) {
    const sWrapper = $element.querySelector(".swiper-wrapper");
    let hasMultipleColumns = false;

    if (!sWrapper || sWrapper.children.length < 2) {
      bcl.u.removeClass($element, "cmp-bhg-swiper-js");

      if (!props.skipWrapperOverflow) {
        bcl.u.swiper.changeParent($element);
      }

      const $buttons = $element.querySelectorAll(".swiper-button-JS");
      bcl.u.forEach($buttons, function ($button) {
        if ($button.parentNode) {
          $button.parentNode.removeChild($button);
        }
      });

      return null;
    }

    const ds = $element.dataset;
    const properties = bcl.u.deepExtend({}, props.config || {});

    if (properties.navigation) {
      properties.navigation.prevEl = $element.querySelector(".swiper-button-prev");
      properties.navigation.nextEl = $element.querySelector(".swiper-button-next");
    }

    let slides = null;

    if (ds.numberslidesmobile && bcl.u.mobile.isMobile()) {
      slides = ds.numberslidesmobile;
    }

    if (slides || ds.numberslides) {
      properties.slidesPerView = slides || ds.numberslides || "auto";
      properties.spaceBetween = ds.spacebetween ? parseInt(ds.spacebetween, 10) : 15;

      if (properties.pagination) {
        const pagType = properties.pagination.type || ds.paginationtype;

        if (pagType === "fraction") {
          properties.pagination.type = "fraction";
        } else {
          delete properties.pagination.type;
        }
        properties.pagination.clickable = true;
      }

      if (ds.numberslides) {
        properties.breakpoints = properties.breakpoints || {};
        properties.breakpoints[bcl.u.breakMobile] = {
          slidesPerView: ds.numberslides,
          spaceBetween: ds.spacebetween ? parseInt(ds.spacebetween, 10) : 0,
        };
      }
    }

    if (ds.slideperviewauto === "true") {
      properties.slidesPerView = "auto";
    }

    if (ds.centerslides === "true") {
      properties.centeredSlides = true;
    }

    if (!properties.loop && ds.loop === "true") {
      properties.loop = true;
    }

    if (ds.autoplay === "true") {
      properties.loop = true;
      properties.autoplay = {
        delay: parseInt(ds.delay, 10) || 3000,
        disableOnInteraction: ds.disableoninteraction === "true",
      };
    }

    if (ds.index) {
      properties.initialSlide = parseInt(ds.index, 10);
    }

    if (parseInt(ds.slidespercolumn, 10) > 1) {
      properties.grid = {
        rows: parseInt(ds.slidespercolumn, 10),
        fill: "row",
      };
      properties.centeredSlides = false;
      hasMultipleColumns = true;
    }

    if (ds.pointpagination === "true" || $element.closest(".pag-bullets-true-JS")) {
      if (properties.pagination && properties.pagination.type !== "fraction") {
        delete properties.pagination.type;
        properties.pagination.renderBullet = function (index, className) {
          return `<span class="${className} ${className}-${index}"></span>`;
        };
      }
    }

    if (($element.id && $element.id.includes("detail_carousel")) || (ds.disablepagination && ds.disablepagination === "true")) {
      if (properties.pagination && properties.pagination.type === "fraction") {
        properties.pagination.clickable = true;
      } else {
        properties.pagination = false;
      }
    } else {
      if (ds.clickable === "true" && properties.pagination) {
        properties.pagination.clickable = true;
      }

      if (ds.mousewheel === "true") {
        properties.mousewheel = { releaseOnEdges: true };
      }
    }

    if (bcl.editMode) {
      properties.loop = false;
    }

    properties.init = false;

    const SwiperConstructor = WIN.Swiper?.default || WIN.Swiper;
    if (!SwiperConstructor) {
      console.error("Swiper init error: Swiper constructor is not available");
      return null;
    }

    const mySwiper = new SwiperConstructor($element, properties);

    const addKeyboardSupport = function (element) {
      const nodes = element instanceof NodeList || Array.isArray(element) ? element : [element];

      nodes.forEach(function (button) {
        if (!button || button.dataset.keyboardSupportAttached === "true") {
          return;
        }

        button.addEventListener("keydown", function (event) {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            this.click();
          }
        });

        button.dataset.keyboardSupportAttached = "true";
      });
    };

    let lastActive = -1;

    const toggleAriaDisabled = function (element, isDisabled) {
      const nodes = element instanceof NodeList || Array.isArray(element) ? element : [element];

      nodes.forEach(function (el) {
        if (!el) {
          return;
        }

        if (isDisabled) {
          el.setAttribute("aria-disabled", "true");
        } else {
          el.removeAttribute("aria-disabled");
        }
      });
    };

    const updateNavigationAria = function () {
      if (!mySwiper?.slides?.length) {
        return;
      }

      const slidesList = mySwiper.slides;
      const navigation = mySwiper.navigation;
      const activeIndex = mySwiper.activeIndex;
      const pagination = mySwiper.pagination;

      if (lastActive !== -1 && slidesList[lastActive]) {
        slidesList[lastActive].setAttribute("aria-hidden", "true");
      }

      if (slidesList[activeIndex]) {
        slidesList[activeIndex].removeAttribute("aria-hidden");
      }

      if (pagination?.bullets?.length) {
        const bullets = pagination.bullets;

        if (lastActive !== -1 && bullets[lastActive]) {
          bullets[lastActive].removeAttribute("aria-current");
        }

        if (bullets[activeIndex]) {
          bullets[activeIndex].setAttribute("aria-current", "true");
        }
      }

      if (mySwiper.el?.closest(".tingle-modal-box")) {
        const i18n = {
          "es-ES": `Mostrando ${activeIndex + 1} de ${slidesList.length}`,
          "en-US": `Showing ${activeIndex + 1} of ${slidesList.length}`,
        };
        const lang = DOC_EL.lang || "en-US";
        const message = i18n[lang] || i18n["en-US"];
        bcl.ariaUtils.announce(message);
      }

      if (navigation?.prevEl && navigation?.nextEl) {
        const isFirst = activeIndex === 0;
        const isLast = activeIndex === slidesList.length - 1;
        toggleAriaDisabled(navigation.prevEl, isFirst);
        toggleAriaDisabled(navigation.nextEl, isLast);
      }

      lastActive = activeIndex;
    };

    const initAccesibilityBullets = function () {
      const bullets = mySwiper?.pagination?.bullets;

      if (bullets && bullets.length > 0) {
        const activeIndex = mySwiper.activeIndex;

        for (let i = 0; i < bullets.length; i++) {
          const bullet = bullets[i];
          bullet.setAttribute("role", "button");
          bullet.setAttribute("tabindex", "0");
          bullet.setAttribute("aria-label", `Slide ${i + 1}`);

          if (i === activeIndex) {
            bullet.setAttribute("aria-current", "true");
          } else {
            bullet.removeAttribute("aria-current");
          }

          addKeyboardSupport(bullet);
        }
      }
    };

    mySwiper.on("init", function () {
      const $items = $element.querySelectorAll(".swiper-slide-duplicate .cmp-image .cmp-image__image--is-loading");

      if ($items.length) {
        bcl.u.forEach($items, function ($item) {
          bcl.u.resetImage($item.parentNode);
        });
      }

      if (mySwiper.navigation?.prevEl && mySwiper.navigation?.nextEl) {
        initAccesibilityBullets();
        updateNavigationAria();
        addKeyboardSupport(mySwiper.navigation.prevEl);
        addKeyboardSupport(mySwiper.navigation.nextEl);
      }
    });

    mySwiper.init();

    mySwiper.on("slideChange", function () {
      updateNavigationAria();
    });

    mySwiper.on("sliderMove", function () {
      if (!bcl.u.mobile.isMobile() && mySwiper.slides) {
        const currentSlide = mySwiper.slides[mySwiper.activeIndex];
        if (currentSlide && bcl.u.closest(currentSlide, ".swiper")) {
          bcl.c?.assetVideo?.stopAllVideosWithSound(currentSlide);
        }
      }
    });

    if (!props.skipWrapperOverflow) {
      bcl.u.swiper.changeParent($element, hasMultipleColumns);
    }

    if ($element && bcl.editMode) {
      if (WIN.Granite && WIN.window.Granite && WIN.window.Granite.author && WIN.window.Granite.author.MessageChannel) {
        new WIN.window.Granite.author.MessageChannel("cqauthor", WIN).subscribeRequestMessage("cmp.panelcontainer", function (message) {
          const elemDatasetCmpPanelcontainerId = $element.dataset.cmpPanelcontainerId;

          if (message.data && message.data.type === props.cssSelector && message.data.id === elemDatasetCmpPanelcontainerId && message.data.operation === "navigate") {
            mySwiper.slideTo(message.data.index, 1000, true);
          }
        });
      }
    }

    return mySwiper;
  },

  init: async function (baseDom, properties) {
    try {
      let swiper = null;
      const baseFind = baseDom || DOC;
      const elements = baseFind.getElementsByClassName(properties.cssSelector);

      const configureWhenNeeded = async ($element) => {
        const wrapper = $element.querySelector(".swiper-wrapper");

        if (wrapper?.children.length >= 2) {
          if (swiperPendingElements.has($element)) {
            return $element.swiper || null;
          }

          const needsFullProfile = swiperConfigNeedsFullProfile(properties.config) || swiperElementNeedsFullProfile($element);
          const loadSwiperRuntime = needsFullProfile ? ensureSwiper : ensureBasicSwiper;

          swiperPendingElements.add($element);
          try {
            await loadSwiperRuntime();
          } finally {
            swiperPendingElements.delete($element);
          }

          if (!$element.isConnected || $element.swiper) {
            return $element.swiper || null;
          }
        }

        return bcl.u.swiper.configure($element, properties);
      };

      for (let i = 0; i < elements.length; i++) {
        const $element = elements[i];

        if ($element?.swiper) {
          continue;
        }

        $element.classList.add("element-" + i);

        const asyncObj = $element.querySelector(properties.cssSelectorSwiper);

        if (asyncObj && !asyncObj.innerHTML.trim()) {
          let dataInfo = null;

          if (properties?.nameAttr) {
            dataInfo = asyncObj.getAttribute(properties.nameAttr);
            if (dataInfo) {
              dataInfo += bcl.u.mobile.isMobile() ? "?isMobile=true" : "";
            }
          }

          if (dataInfo && dataInfo !== "null") {
            if (!pendingAsyncSwiperLoads.has(asyncObj)) {
              pendingAsyncSwiperLoads.add(asyncObj);

              const showBackupImage = () => {
                const backupImg = (asyncObj.closest(".cmp-bhg-carousel") || asyncObj).querySelector(".no-carousel-backup-JS");
                if (backupImg) {
                  backupImg.classList.remove("hidden");
                  WIN.dispatchEvent(new Event("update"));
                }
              };

              const handleLoaded = () => {
                pendingAsyncSwiperLoads.delete(asyncObj);
                asyncObj.removeAttribute(properties.nameAttr);

                if (!asyncObj.innerHTML.trim()) {
                  showBackupImage();
                }

                configureWhenNeeded($element)
                  .then((instance) => {
                    swiper = instance;
                  })
                  .catch((error) => {
                    console.error("Swiper init error:", error);
                  });
              };

              const handleFailed = () => {
                pendingAsyncSwiperLoads.delete(asyncObj);
                asyncObj.removeAttribute(properties.nameAttr);
                showBackupImage();
              };

              const prefetched = bcl.modal?.consumePrefetchedCarouselResponse?.(dataInfo);

              if (prefetched) {
                prefetched.then((response) => {
                  if (response) {
                    asyncObj.innerHTML = response.responseText;
                    document.dispatchEvent(new CustomEvent("ajax-executed", { detail: asyncObj }));
                    handleLoaded();
                  } else {
                    bcl.ajax.getRequest(asyncObj, dataInfo, handleLoaded, null, null, handleFailed);
                  }
                });
              } else {
                bcl.ajax.getRequest(asyncObj, dataInfo, handleLoaded, null, null, handleFailed);
              }
            }

            continue;
          }
        }

        swiper = await configureWhenNeeded($element);
      }

      return swiper;
    } catch (err) {
      console.error("Swiper init error:", err);
      return null;
    }
  },
};

//----------------------------------------------------------------//
//--------------------------- T ---------------------------//
//----------------------------------------------------------------//

bcl.u.textareaCountWords = function ($textarea, maximuncharacters, message) {
  let totalCharacters;
  if (message === undefined) {
    if ($textarea.value.length < maximuncharacters) {
      totalCharacters = maximuncharacters - $textarea.value.length;
    } else {
      totalCharacters = maximuncharacters;
    }
  }
  return totalCharacters;
};

//----------------------------------------------------------------//

bcl.u.toggleClass = function ($el, className) {
  if (!$el) {
    return;
  }

  if ($el.classList) {
    $el.classList.toggle(className);
  } else {
    const classes = $el.className.split(" ");
    const existingIndex = classes.indexOf(className);

    if (existingIndex >= 0) {
      classes.splice(existingIndex, 1);
    } else {
      classes.push(className);
    }

    $el.className = classes.join(" ");
  }
};

//----------------------------------------------------------------//

bcl.u.triggerEvent = function (el, type) {
  let e;
  if ("createEvent" in DOC) {
    e = DOC.createEvent("HTMLEvents");
    e.initEvent(type, false, true);
    el.dispatchEvent(e);
  } else {
    e = DOC.createEventObject();
    e.eventType = type;
    el.fireEvent("on" + e.eventType, e);
  }
};

//----------------------------------------------------------------//
//--------------------------- U ---------------------------//
//----------------------------------------------------------------//

bcl.u.updateClassByDotsScore = function ($subNode, value, i) {
  const classNameFull = "ta__dot--full";
  const classNameHalf = "ta__dot--half";
  const classNameEmpty = "empty";

  if (value >= i + 1) {
    bcl.u.addClass($subNode, classNameFull);
  } else if (value >= i + 0.5) {
    bcl.u.addClass($subNode, classNameHalf);
  } else {
    bcl.u.addClass($subNode, classNameEmpty);
  }
};

//----------------------------------------------------------------//
//--------------------------- V ---------------------------//
//----------------------------------------------------------------//

bcl.u.validateEmail = function (mail) {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(mail);
};

//----------------------------------------------------------------//
//--------------------------- W ---------------------------//
//----------------------------------------------------------------//

bcl.u.wrap = function (el, wrapper) {
  if (!el || !wrapper) {
    return null;
  }
  el.parentNode.insertBefore(wrapper, el);
  return wrapper.appendChild(el);
};

//----------------------------------------------------------------//
//--------------------------- END ---------------------------//
//----------------------------------------------------------------//

WIN.$body = (function () {
  if (bcl.u.mobile.iOS()) {
    return DOC.querySelector("body");
  }
  return DOC.querySelector("html, body");
})();
